import { useMemo } from "react";

export function useFormattedOptions(
  data,
  isLoading,
  defaultOptions,
  getLabel,
  getValue
) {
  return useMemo(() => {
    if (isLoading || !data || !data.length) {
      return defaultOptions;
    }

    if (typeof data[0] === "string" || typeof data[0] === "number") {
      return data.map((item) => ({
        label: String(item),
        value: item,
      }));
    }

    if (getLabel && getValue) {
      return data.map((item) => ({
        label: getLabel(item),
        value: getValue(item),
      }));
    }

    return defaultOptions;
  }, [data, isLoading]);
}
